import React from 'react';
import ModalLayout from '../ModalLayout';
import PropTypes from 'prop-types';
import OrderHistoryList from './OrderHistoryList';
import OrderHistoryDetails from './OrderHistoryDetails';
import Fader from '../Fader';
import FaderTitle from '../Fader/FaderTitle';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import { translate } from 'react-i18next';
import { Modal } from 'wix-style-react';

class OrderHistory extends React.PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    displayableOrders: PropTypes.array,
    orders: PropTypes.array,
    onAddToOrderClick: PropTypes.func,
    orderAddress: PropTypes.object,
    restaurantAddress: PropTypes.object,
    t: PropTypes.func,
  };

  static defaultProps = {
    orders: [],
    displayableOrders: [],
  };

  constructor(props) {
    super(props);
    this.ORDER_DETAILS_TITLE = props.t('phoneordering_menu_orderhistory_title');
    this.ORDER_HISTORY_TITLE = props.t('phoneordering_menu_orderhistory_title');

    this.state = { orderIndex: null, isOrderVisible: false };
  }

  _handleOrderClick = ({ orderIndex }) => {
    this.setState({ orderIndex, isOrderVisible: true });
  };

  _handleBackClick = () => {
    this.setState({ isOrderVisible: false });
  };

  _handleCloseClick = () => {
    const { onRequestClose } = this.props;
    onRequestClose();
  };

  _handleAddToOrderClick = () => {
    const { orderIndex } = this.state;
    const { onAddToOrderClick, orders, onRequestClose } = this.props;
    const { orderItems } = orders[orderIndex];
    onAddToOrderClick({ orderItems });
    onRequestClose();
    this.setState({ isOrderVisible: false });
  };

  render() {
    const { isOpen, displayableOrders, orderAddress, restaurantAddress } = this.props;
    const { orderIndex, isOrderVisible } = this.state;
    const displayableOrder = displayableOrders[orderIndex];
    const title = (
      <FaderTitle
        primary={this.ORDER_HISTORY_TITLE}
        secondary={this.ORDER_DETAILS_TITLE}
        drilldown={isOrderVisible}
        onBackClick={this._handleBackClick}
      />
    );

    const primary = <OrderHistoryList displayableOrders={displayableOrders} onOrderClick={this._handleOrderClick} />;

    const secondary = (
      <OrderHistoryDetails
        restaurantAddress={restaurantAddress}
        orderAddress={orderAddress}
        displayableOrder={displayableOrder}
        onAddToOrderClick={this._handleAddToOrderClick}
      />
    );

    const footer = (
      <BasicModalLayoutFooter onOkClick={this._handleCloseClick} okText={'Close'} displayCancelButton={false} />
    );

    return (
      <Modal isOpen={isOpen} onRequestClose={this._handleCloseClick} shouldCloseOnOverlayClick>
        <ModalLayout
          footer={footer}
          title={title}
          onCloseClick={this._handleCloseClick}
          contentPadding="0 12px"
          paddingBottom="10px"
        >
          <Fader primary={primary} secondary={secondary} drilldown={isOrderVisible} dynamicHeight delayedEnter />
        </ModalLayout>
      </Modal>
    );
  }
}

export default translate()(OrderHistory);
